import theme from 'styles/theme'

type NextShapeProps = {
  topMobile?: boolean
  topDesk?: boolean
  upSideDown?: boolean
  color: 'lightPink' | 'white' | 'midWhite' | 'purple' | undefined
  className?: string
}

export default function NextStepShapeLightPink({
  topMobile,
  topDesk,
  upSideDown,
  color,
  className
}: NextShapeProps) {
  return (
    <>
      {topMobile && (
        <svg
          className={className}
          viewBox="0 0 375 34"
          style={{ transform: upSideDown ? 'scale(-1, -1)' : 'scale(1)' }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M375 378.5L0 378.5L3.07291e-05 27C131.5 27 147.5 1.28949e-05 375 3.27835e-05L375 378.5Z"
            fill="#F7F0FE"
          />
        </svg>
      )}

      {topDesk && (
        <>
          {color ? (
            <svg
              className={className}
              fill={theme.colors[color]}
              style={{ transform: upSideDown ? 'scale(-1, -1)' : 'scale(1)' }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 50"
              preserveAspectRatio="none"
            >
              <path
                opacity="0.4"
                d="M1366 494.499L0.000122595 494.5L0.000171628 36.5247C677 36.5247 825.5 -19.975 1366 9.52423L1366 494.499Z"
                fill="#ECD9FC"
              />
            </svg>
          ) : (
            <svg
              className={className}
              viewBox="0 0 1366 50"
              style={{ transform: upSideDown ? 'scale(-1, -1)' : 'scale(1)' }}
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
            >
              <path
                opacity="0.4"
                d="M1366 494.499L0.000122595 494.5L0.000171628 36.5247C677 36.5247 825.5 -19.975 1366 9.52423L1366 494.499Z"
                fill="#ECD9FC"
              />
            </svg>
          )}
        </>
      )}
    </>
  )
}
